import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from '@material-ui/core';
import isMobile from 'ismobilejs';
import Loading from '../loading';

const styles = theme => ({
  root: {
    padding: 0,
  },
  heading: {
    fontSize: theme.typography.pxToRem(18),
    flexBasis: '80%',
    flexShrink: 0,
    color: '#FFFFFF',
  },
  expansionPanelSummary: {
    backgroundColor: '#4e91fd',
    height: 40,
  },
  expansionPanelDetails: {
    padding: 0,
  },
  expandMoreIcon: {
    color: '#FFFFFF',
    height: 30,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  dialogContent: {
    padding: 15,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: isMobile.phone ? 'calc(90%)' : '200px',
    borderBottom: 0,
  },
  button: {
    margin: theme.spacing.unit,
    color: theme.palette.background.default,
    backgroundColor: '#4e91fd',
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
});

class SelectSupplierModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      supplierId: props.currentSupplierId,
      errorMessage: '',
      suppliers: props.suppliers,
      isFetching: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = event => {
    this.setState({ supplierId: Number(event.target.value) });
  };

  handleSubmit() {
    this.props.onSubmit(this.state.supplierId);
  }

  render() {
    const { classes } = this.props;
    const { isFetching, errorMessage, suppliers, supplierId } = this.state;
    return (
      <div>
        <Dialog
          fullWidth={false}
          maxWidth={false}
          open
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Select Supplier</DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <div className={classes.paper}>
              {errorMessage && <label value={errorMessage} />}
              {!errorMessage && (
                <FormControl component="fieldset">
                  <FormLabel component="legend"></FormLabel>
                  <RadioGroup
                    aria-label="gender"
                    name="MarketPlace_Suppliers"
                    value={supplierId}
                    onChange={this.handleChange}
                  >
                    {suppliers &&
                      suppliers.map(supplier => (
                        <FormControlLabel
                          value={supplier.id}
                          control={<Radio />}
                          label={`${supplier.name} (${supplier.id})`}
                        />
                      ))}
                  </RadioGroup>
                </FormControl>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleSubmit()} className={classes.button}>
              Switch
            </Button>
            <Button onClick={() => this.props.onClose()} className={classes.button}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Loading show={isFetching} text="Loading..." />
      </div>
    );
  }
}

SelectSupplierModal.propTypes = {
  currentSupplierId: PropTypes.number,
  suppliers: PropTypes.array,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};
export default withStyles(styles)(SelectSupplierModal);



// WEBPACK FOOTER //
// ./src/components/modals/SelectSupplierModal.js